import { MARKETING_URL_PARAMS } from '@constants/urlParams'

const getTrackingParamsFromCookies = (cookieHeader: string | null) => {
  if (!cookieHeader) return null
  const cookies = cookieHeader?.split(';')
  let domainUserId

  cookies.forEach(cookie => {
    if (cookie.trim().startsWith('_sp_id')) {
      domainUserId = cookie.split('=')[1].split('.')[0]
    }
  })

  return { domainUserId }
}

const getTrackingParamsFromSearchParams = (searchParams: URLSearchParams) => {
  type TrackingParams = {
    [K in (typeof MARKETING_URL_PARAMS)[number]]: string | undefined | null
  }
  const trackingParams: TrackingParams = {}

  MARKETING_URL_PARAMS.forEach(param => {
    if (searchParams.has(param)) {
      trackingParams[param] = searchParams.get(param)
    }
  })

  return trackingParams
}

export const getTrackingParams = (
  cookieHeader: string | null,
  searchParams: URLSearchParams
) => {
  return {
    ...getTrackingParamsFromCookies(cookieHeader),
    ...getTrackingParamsFromSearchParams(searchParams),
  }
}

export const addTrackingParamsToUrl = (url: string, trackingParams: any) => {
  let newUrl = url.includes('?') ? url + '&' : url + '?'
  Object.keys(trackingParams).forEach((key, index, array) => {
    if (index !== array.length - 1) {
      newUrl += `${key}=${trackingParams[key]}&`
    } else {
      newUrl += `${key}=${trackingParams[key]}`
    }
  })

  return newUrl
}
